import Extension from "./Extension";

const extension = new Extension();
extension.init();